module.exports = __webpack_public_path__ + "static/media/flyer-new-1.381e4596.jpeg";